import React from 'react';
// import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const TermsAndConditions = () => {
    return (
        <div className="terms-page">
            <Header />
            <div className="terms-container">
                <div className="terms-content">
                    <div className="terms-header">
                        <h1>Terms & Conditions for meDZhub</h1>
                        <p className="last-updated">Last Updated: 24/11/2025</p>
                    </div>

                    <div className="terms-intro">
                        <p>
                            Welcome to meDZhub, a mobile application operated by Dhruthzuci Tech Solutions Pvt. Ltd. ("Company", "we", "our", or "us").
                        </p>
                        <p>
                            By accessing or using the meDZhub mobile application ("App"), you ("User", "Therapist", or "You") agree to be bound by these Terms & Conditions.
                        </p>
                        <p className="terms-warning">
                            If you do not agree to these Terms, please do not use the App.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>1. Eligibility</h2>
                        <ul>
                            <li>The App is intended only for authorized therapists, staff, and providers who have been granted login credentials by the organization associated with meDZhub.</li>
                            <li>Users must be 18 years or older.</li>
                            <li>Unauthorized use of the App is strictly prohibited.</li>
                        </ul>
                    </div>

                    <div className="terms-section">
                        <h2>2. User Accounts & Security</h2>
                        <ul>
                            <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
                            <li>You agree to notify us immediately of any unauthorized access or breach.</li>
                            <li>You must not share, sell, or transfer your account to any third party.</li>
                            <li>The App may restrict or suspend accounts suspected of misuse.</li>
                        </ul>
                    </div>

                    <div className="terms-section">
                        <h2>3. Purpose of the App</h2>
                        <p>meDZhub is a workflow and activity management application designed for:</p>
                        <ul>
                            <li>Managing therapy schedules</li>
                            <li>Recording session-related information</li>
                            <li>Managing patient workflows (as applicable)</li>
                            <li>Communication and coordination between authorized healthcare staff</li>
                        </ul>
                        <p>The App is not intended for public use or direct patient access.</p>
                    </div>

                    <div className="terms-section">
                        <h2>4. Acceptable Use</h2>
                        <p>By using the App, you agree:</p>
                        <ul className="terms-agree-list">
                            <li>✔ To use the App only for legitimate and authorized professional activities</li>
                            <li>✔ To provide accurate information at all times</li>
                            <li>✔ To comply with all local laws and organizational guidelines</li>
                        </ul>
                        <p>You agree NOT to:</p>
                        <ul className="terms-disagree-list">
                            <li>✘ Misuse, reverse-engineer, or tamper with the App</li>
                            <li>✘ Upload harmful, illegal, or unauthorized content</li>
                            <li>✘ Use the App to harass, harm, or exploit any individual</li>
                            <li>✘ Attempt to gain unauthorized access to other users' data</li>
                        </ul>
                        <p className="terms-warning">
                            Violation of these rules may lead to suspension or permanent termination of access.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>5. Data Usage & Responsibility</h2>
                        <ul>
                            <li>meDZhub may store and process activity-related data for operational purposes.</li>
                            <li>Users must ensure that any data they enter is accurate and appropriate for professional use.</li>
                            <li>Therapists are responsible for ensuring they follow their organization's policies regarding patient-related data or sensitive information.</li>
                        </ul>
                    </div>

                    <div className="terms-section">
                        <h2>6. Privacy</h2>
                        <p>
                            Your use of the App is also governed by our Privacy Policy, which explains how we collect, use, store, and protect your data.
                        </p>
                        <p>
                            You must review and agree to the Privacy Policy before using the App.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>7. Intellectual Property</h2>
                        <ul>
                            <li>All content, code, UI/UX elements, and branding in the App are the property of Dhruthzuci Tech Solutions Pvt. Ltd.</li>
                            <li>You may not copy, reuse, modify, distribute, or reverse-engineer any part of the App without written permission.</li>
                        </ul>
                    </div>

                    <div className="terms-section">
                        <h2>8. App Availability & Updates</h2>
                        <ul>
                            <li>We may update, modify, or discontinue certain features without prior notice.</li>
                            <li>We do not guarantee uninterrupted availability of the App.</li>
                            <li>You are responsible for installing updates for best performance.</li>
                        </ul>
                    </div>

                    <div className="terms-section">
                        <h2>9. Limitation of Liability</h2>
                        <p>
                            The App is provided "as-is" and "as available" without warranties of any kind.
                        </p>
                        <p>To the maximum extent permitted by law, the Company is not liable for:</p>
                        <ul>
                            <li>Data loss</li>
                            <li>Service interruptions</li>
                            <li>Errors caused by user misuse</li>
                            <li>Delays due to network issues</li>
                            <li>Issues arising from third-party integrations or user devices</li>
                        </ul>
                        <p>Your organization may provide additional internal policies which also apply.</p>
                    </div>

                    <div className="terms-section">
                        <h2>10. Termination</h2>
                        <p>We may suspend or terminate your access to the App at any time if:</p>
                        <ul>
                            <li>You violate these Terms</li>
                            <li>Your organization removes your access</li>
                            <li>You misuse or attempt to compromise the system</li>
                        </ul>
                        <p>Upon termination, you must stop using and uninstall the App.</p>
                    </div>

                    <div className="terms-section">
                        <h2>11. Changes to Terms</h2>
                        <p>
                            We may revise these Terms periodically. Continued use of the App signifies your acceptance of any updated terms.
                        </p>
                    </div>

                    <div className="terms-section">
                        <h2>12. Contact Information</h2>
                        <p>For any questions, support, or requests related to these Terms, contact:</p>
                        <div className="terms-contact">
                            <p><strong>Dhruthzuci Tech Solutions Pvt. Ltd.</strong></p>
                            <p>Email: <a href="mailto:medzhub@eshatechgroup.com">medzhub@eshatechgroup.com</a></p>
                            <p>Website: <a href="https://medzhub.eshatechgroup.com" target="_blank" rel="noopener noreferrer">https://medzhub.eshatechgroup.com</a></p>
                            <p>Phone: <a href="tel:+918031196612">+91 8031196612</a></p>
                        </div>
                    </div>

                    {/* <div className="terms-back">
                        <Link to="/" className="btn btn-primary">Back to Home</Link>
                    </div> */}
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default TermsAndConditions;

